import useI18n from './useI18n';
import {
  ISupportedSocialsMedia,
  socialsMedia,
  socialsMedia_DEFAULT,
} from '@monofront/business/constants';

const useLocalizedSocialsMedia = (): ISupportedSocialsMedia => {
  const { locale } = useI18n();

  return socialsMedia[locale] || socialsMedia_DEFAULT;
};

export default useLocalizedSocialsMedia;
